// extracted by mini-css-extract-plugin
module.exports = {"footNotes":"footnotes_footNotes__sOu7e","container":"footnotes_container__1Tc8D"};